// This component checks if the user is authenticated by verifying the JWT token.
// If the token is valid, it allows access to the protected routes; otherwise, it redirects to the login page.

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const isTokenValid = (bearerToken) => {
  if (!bearerToken) return false;

  try {
    const token = bearerToken.split(' ')[1]; // safely extract JWT from 'Bearer <token>'
    const base64Url = token.split('.')[1];
    const decoded = JSON.parse(atob(base64Url));

    const currentTime = Math.floor(Date.now() / 1000);
    return decoded.exp && decoded.exp > currentTime;
  } catch (err) {
    console.error('Invalid token format', err);
    return false;
  }
};

export const AuthRoute = () => {
  const bearerToken = localStorage.getItem('token'); // always has 'Bearer ' prefix now

  if (!bearerToken) {
    console.log('No token found. Redirecting to login.');
    return <Navigate to="/" replace />;
  }

  if (!isTokenValid(bearerToken)) {
    console.log('Token expired or invalid. Logging out...');
    localStorage.removeItem('token');
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
